module.exports = __webpack_public_path__ + "364cbda8b5a389ded1a457e36aab5532.svg";